import { useQuery } from '@apollo/client';
import { useClearAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type { MtSettingsBuyerGetProfileQuery } from '@gql/graphql';

export const MT_SETTINGS_BUYER_GET_PROFILE = graphql(`
  query MtSettingsBuyerGetProfile {
    accountMe {
      ...CurrentAccountInfo
      birthday
      gender
      contactPreferences
    }
  }
`);

export const useGetProfile = () => {
  const { redirectOnTokenErrorHandler } = useClearAccount();

  const { data, loading, error } = useQuery<MtSettingsBuyerGetProfileQuery>(
    MT_SETTINGS_BUYER_GET_PROFILE,
    {
      onError: redirectOnTokenErrorHandler,
      ssr: false,
    },
  );

  return { profile: data?.accountMe, profileError: error, profileLoading: loading };
};
